import script from "./PatientIntakeReview.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientIntakeReview.vue?vue&type=script&setup=true&lang=js"

import "./PatientIntakeReview.vue?vue&type=style&index=0&id=398e5f97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398e5f97"]])

export default __exports__